const getFiscalYear = (year) => {
  const currentYear = new Date().toLocaleDateString("en-US", {
    month: "2-digit",
    year: "numeric",
    day: "2-digit",
  });

  const currentFiscalYear = new Date(
    new Date().setFullYear(new Date().getFullYear() - 1, 3, 1)
  ).toLocaleDateString("en-US", {
    month: "2-digit",
    year: "numeric",
    day: "2-digit",
  });
  if (currentYear < currentFiscalYear) {
    const diff = 1;
    const fiscalYearStart = new Date(
      new Date().setFullYear(new Date().getFullYear() - diff + year, 3, 1)
    ).toLocaleDateString("en-US", {
      month: "2-digit",
      year: "numeric",
      day: "2-digit",
    });
    const fiscalYearEnd = new Date(
      new Date().setFullYear(new Date().getFullYear() - diff + year + 1, 2, 31)
    ).toLocaleDateString("en-US", {
      month: "2-digit",
      year: "numeric",
      day: "2-digit",
    });
    return [fiscalYearStart, fiscalYearEnd];
  } else {
    const diff = 0;
    const fiscalYearStart = new Date(
      new Date().setFullYear(new Date().getFullYear() + year - diff, 3, 1)
    ).toLocaleDateString("en-US", {
      month: "2-digit",
      year: "numeric",
      day: "2-digit",
    });
    const fiscalYearEnd = new Date(
      new Date().setFullYear(new Date().getFullYear() + year - diff + 1, 2, 31)
    ).toLocaleDateString("en-US", {
      month: "2-digit",
      year: "numeric",
      day: "2-digit",
    });
    return [fiscalYearStart, fiscalYearEnd];
  }
};

export default getFiscalYear;
